
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderAddressDialog extends Serenity.EntityDialog<ECommOrderAddressRow, any> {
        protected getFormKey() { return ECommOrderAddressForm.formKey; }
        protected getIdProperty() { return ECommOrderAddressRow.idProperty; }
        protected getLocalTextPrefix() { return ECommOrderAddressRow.localTextPrefix; }
        protected getNameProperty() { return ECommOrderAddressRow.nameProperty; }
        protected getService() { return ECommOrderAddressService.baseUrl; }
        protected getDeletePermission() { return ECommOrderAddressRow.deletePermission; }
        protected getInsertPermission() { return ECommOrderAddressRow.insertPermission; }
        protected getUpdatePermission() { return ECommOrderAddressRow.updatePermission; }

        protected form = new ECommOrderAddressForm(this.idPrefix);

    }
}